import { checkboxAnatomy as n } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as d } from "@chakra-ui/react";
import { buttonTheme as i } from "./button.mjs";
import { iconSizes as l } from "../../foundations/icons.mjs";
const { defineMultiStyleConfig: b, definePartsStyle: o } = d(n.keys), s = {
  sm: o({
    control: {
      h: 4,
      w: 4,
      marginTop: { base: "2px", md: "4px" }
    },
    label: {
      textStyle: "bodySmall"
    },
    icon: {
      fontSize: l.xs
    }
  }),
  md: o({
    control: {
      w: 5,
      h: 5,
      marginTop: "2px"
    },
    label: {
      textStyle: "body"
    },
    icon: {
      fontSize: l.md
    }
  })
}, c = o(({ size: r }) => {
  const e = s[r];
  return {
    icon: {
      transitionProperty: "transform",
      transitionDuration: "normal",
      ...e.icon
    },
    container: {
      alignItems: "start",
      WebkitAlignItems: "start",
      _disabled: { cursor: "not-allowed" }
    },
    label: {
      color: "black",
      userSelect: "none",
      _disabled: { opacity: 0.5 },
      ...e.label
    },
    control: {
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      border: "2px solid",
      borderRadius: "base",
      borderColor: "gray.200",
      color: "white",
      backgroundColor: "white",
      ...e.control,
      _hover: {
        borderColor: "gray.300"
      },
      _checked: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white",
        _hover: {
          bg: "teal.600",
          borderColor: "teal.600"
        },
        _disabled: {
          borderColor: "gray.200",
          bg: "gray.200",
          color: "gray.500"
        }
      },
      _indeterminate: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white"
      },
      _disabled: {
        bg: "gray.200",
        borderColor: "gray.200",
        opacity: 0.5
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _invalid: {
        borderColor: "red.500",
        _focusVisible: {
          boxShadow: "invalidOutline"
        }
      }
    }
  };
}), p = o(() => ({
  size: {},
  icon: { display: "none" },
  container: {
    borderColor: "teal.500",
    borderWidth: "1px",
    borderRadius: "lg",
    bg: "white",
    p: 4,
    pb: 10,
    width: "fit-content",
    textStyle: "body",
    _hover: {
      borderColor: "teal.700",
      bg: "teal.50",
      _disabled: {
        borderColor: "gray.200",
        bg: "initial"
      }
    },
    _focusWithin: {
      p: "15px",
      pb: "39px",
      borderColor: "teal.500",
      borderWidth: "2px",
      boxShadow: "outline"
    },
    _checked: {
      borderColor: "teal.500",
      bg: "teal.25",
      ".checkbox-card-selected-badge": {
        display: "inline-block"
      },
      _hover: {
        borderColor: "teal.700",
        bg: "teal.50"
      },
      svg: { display: "none" }
    },
    _invalid: {
      p: "15px",
      pb: "39px",
      borderColor: "red.500",
      borderWidth: "2px",
      bg: "white",
      _focusWithin: {
        boxShadow: "invalidOutline"
      },
      _hover: {
        borderColor: "inherit"
      }
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  },
  label: {
    m: 0,
    w: "100%",
    ".checkbox-card-badge-container": {
      textAlign: "right",
      lineHeight: "0",
      height: { base: "20px", md: "24px" }
    },
    ".checkbox-card-selected-badge": {
      display: "none"
    }
  }
})), h = o(({ size: r, ...e }) => {
  var t;
  const a = (t = i.sizes) == null ? void 0 : t[r];
  return {
    icon: { display: "none" },
    container: {
      width: "fit-content",
      ...i.baseStyle,
      ...a,
      color: "teal.500",
      bg: "white",
      border: "1px solid",
      borderColor: "gray.200",
      _focusWithin: {
        boxShadow: "outline"
      },
      _checked: {
        color: "teal.700",
        bg: "gray.200",
        svg: { display: "none" }
      },
      _invalid: {
        boxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        webkitBoxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        color: "teal.500",
        _focusWithin: {
          boxShadow: "invalidOutline"
        }
      }
    },
    label: { m: 0 }
  };
}), m = b({
  baseStyle: {},
  variants: {
    checkbox: c,
    card: p,
    button: h
  },
  defaultProps: {
    size: "md",
    variant: "checkbox"
  }
});
export {
  m as default
};
